<template>
  <!-- 协会之声 -->
  <div id="Associvoice">
    <Header></Header>
    <Navigate></Navigate>
    <div class="content">
      <div class="crumbs">
        <i class="iconfont icon-zhuye"></i>
        <span><router-link :to="{name:'home'}">首页</router-link></span>
        <i class="iconfont icon-youjiantou"></i>
        <span><a>协会之声</a></span>
      </div>
      <div class="content_body">
        <div class="content_body_left">
          <div class="content_body_left_divA">
            <div class="content_body_left_divA_head">
              <i>|</i>
              <span>协会之声</span>
            </div>
            <div class="content_body_left_divA_cont">
              <li v-for="(item,index) in AssocivoiceList" :key="index">
                <i class="content_body_left_list"></i>
                <router-link :to="{name:item.name}">{{item.title}}</router-link>
                <div style="clear:both"></div>
              </li>
            </div>
          </div>
          <BannerLeft></BannerLeft>
        </div>
        <div class="content_body_right">
          <router-view></router-view>
        </div>
      </div>
      <div style="clear:both"></div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from '@/components/public/heade/index'
import Navigate from '@/components/public/navigation/index'
import Foot from '@/components/public/foot/index'
import BannerLeft from '@/components/public/bannerLeft/index'
export default {
  name:'Associvoice',
  data(){
    return{
      AssocivoiceList:[
        {
          name:'Culturelec',
          title:'文化讲堂'
        },
        {
          name:'Iscommuni',
          title:'情况交流'
        }
      ]
    }
  },
  components:{
    Header,
    Navigate,
    Foot,
    BannerLeft
  }
}
</script>

<style lang="less" scoped>
  #Associvoice{
    width:100%;
    height:auto;
    .content{
      width:1200px;
      height:100%;
      margin:0 auto;
      .crumbs{
        width:1200px;
        height:20px;
        position:relative;
        text-align:left;
        margin-top:24px;
        line-height:20px;
        span:nth-child(2) a{
          color:#000000;
          font-size:16px;
          font-weight:bold;
          cursor:pointer;
        }
        i{
          color:#767C82;
          font-size:18px;
          margin-left:10px;
          font-weight:bold;
        }
        i:nth-child(1){
          color:#000;
          margin-right:5px;
        }
        span:nth-child(4) a{
          color:#C01B22;
          font-size:16px;
          margin-left:10px;
          font-weight:bold;
          cursor:pointer;
        }
      }
      .content_body{
        width: 1130px;
    height: 100%;
    margin-left: 3%;
    margin-top: 20px;
    border: 1px solid #bbbbbb;
        padding-left: 30px;
    padding-right: 30px;
        .content_body_left{
          width:266px;
          height:100%;
          border-right:1px solid #EEEEEE;
          float:left;
          .content_body_left_divA{
            width:266px;
            height:133px;
            background: #F8F8F8;
            position:relative;
            .content_body_left_divA_head{
              width:100%;
              height:48px;
              border-bottom: 6px solid #C01B22;
              top:0;
              margin:0 auto;
              padding:0 5px;
              line-height:42px;
              i{
                font-size:22px;
                color:#000000;
              }
              i:nth-child(1){
                margin-right:15px;
                margin-left: 13px;
              }
              i:nth-child(3){
                float:right;
                position:relative;
                top:3px;
              }
              span{
                color:#000000;
                font-size:20px;
                font-weight: bold;
              }
            }
            .content_body_left_divA_cont{
              width:76%;
              margin:0 auto;
              margin-top:27px;
              li{
                width: 83px;
                height: 20px;
                float: left;
                list-style: none;
                margin-right: 32px;
                margin-bottom: 29px;
                .content_body_left_list{
                  display: inline-block;
                  width: 6px;
                  height: 6px;
                  background: #C01B22;
                  margin-right: 6px;
                  position: relative;
                  top: -3px;
                }
                a{
                  color:#000;
                  font-size:16px;
                  font-family:Source Han Sans SC;
                }
                .router-link-active{
                  color:#C01B22;
                }
              }
              li:nth-child(2n+2){
                margin-right: 0;
              }
              li:hover{
                a{color:#C01B22;}
              }
            }
          }
        }
        .content_body_right{
          width: 1130px;
        height: auto;
        // margin-left: 3%;
          // float:right;
          // margin-left:15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Associvoice/index.vue